import { render, staticRenderFns } from "./DetailConfig.vue?vue&type=template&id=48e6b23d"
import script from "./DetailConfig.js?vue&type=script&lang=js&external"
export * from "./DetailConfig.js?vue&type=script&lang=js&external"
import style0 from "./DetailConfig.vue?vue&type=style&index=0&id=48e6b23d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports